import styled, { css } from "styled-components";
import { dangerFillPulse, warningFillPulse } from "./DashboardStyles";

export const TabNavigation = styled.nav`
  display: grid; gap: 5px; padding-bottom: 10px; flex-shrink: 0;
  button { min-width: 0; min-height: 34px; display: flex; gap: 7px; align-items: center;
    text-align: left; padding: 7px; border: 1px solid transparent; border-radius: 6px;
    background: transparent; color: #b6c9d7; cursor: pointer; font: 600 11px Arial, sans-serif; }
  button[aria-current] { background: #08344a; border-color: #1687bd; color: #f3fcff; }
  button:hover, button:focus-visible { background: #0b2a3c; outline: 1px solid #1b9dd1; }
  svg { flex-shrink: 0; color: #25bbec; }
  b { margin-left: auto; padding: 2px 6px; border-radius: 4px; background: #152e40; }
  button:last-child { font-size: 10px; font-weight: 400; }
`;
export const RotationSettings = styled.div`
  padding: 10px; margin-bottom: 10px; display: grid; gap: 10px; border: 1px solid #285269;
  border-radius: 6px; background: #071a26; color: #c5d5df; font-size: 11px; min-width: 170px;
  label { display: flex; gap: 6px; flex-wrap: wrap; align-items: center; }
  input[type=number] { width: 100%; padding: 6px; background: #020e17; color: white; border: 1px solid #42718b; border-radius: 4px; }
  button { padding: 6px; border: 1px solid #2787af; background: #07334b; color: white; border-radius: 4px; cursor: pointer; }
  [role=alert] { color: #ffc75f; }
`;
export const CloudSidebarList = styled.div`
  display: grid; align-content: start; gap: 6px; min-height: 0; overflow: auto; flex: 1;
  button { background: #061a27; border: 1px solid #1b3c4b; border-radius: 5px; color: #d8e5ed;
    text-align: left; padding: 8px; cursor: pointer; font-size: 11px; }
  button[aria-pressed=true] { border-color: #2aaee9; background: #07324a; }
  small { display: block; margin: 4px 0 0 15px; color: #90adbf; }
  i { width: 7px; height: 7px; border-radius: 50%; display: inline-block; margin-right: 8px; }
`;
export const CloudSidebarFilters = styled.div`
  min-height: 0; flex: 1; display: flex; flex-direction: column;
  > details { display: none; }
  > .cloud-filter-fields { display: flex; flex-direction: column; min-height: 0; flex: 1; }
  @media (max-width: 860px) {
    > .cloud-filter-fields { display: none; }
    > details { display: block; position: relative; }
    summary { list-style: none; color: #25bbec; display: grid; place-items: center; min-height: 34px; cursor: pointer; }
    details > div { position: absolute; top: 0; left: 44px; width: 210px; max-height: 65dvh; overflow: auto; padding: 10px; background: #071a26; border: 1px solid #285269; border-radius: 6px; z-index: 60; }
  }
`;
export const CloudPage = styled.main`
  min-width: 0; min-height: 0; color: #edf6fe; display: flex; flex-direction: column;
  height: ${({ $height }) => $height == null ? "calc(100dvh - 64px)" : `${$height}px`};
  > :not([data-cloud-grid]) { flex-shrink: 0; }
  .cloud-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 8px; flex-wrap: wrap; padding: 0 0 8px; }
  h1 { margin: 0; font-size: clamp(18px, 1.6vw, 26px); }
  .cloud-periods { display: flex; gap: 4px; flex-wrap: wrap; }
  button { cursor: pointer; }
  .cloud-periods button, .cloud-reset { color: #b8d3e3; background: #061b29; border: 1px solid #244759; border-radius: 5px; padding: 7px 12px; }
  .cloud-periods button[aria-pressed=true] { background: #07547c; border-color: #2eafff; color: white; }
  .cloud-message { padding: 12px; border: 1px solid #68501f; color: #ffcf77; background: #221b10; border-radius: 6px; margin-bottom: 12px; font-size: 13px; }
  .cloud-empty { padding: 50px 20px; text-align: center; background: #0a1b27; border: 1px dashed #2d4d61; border-radius: 10px; }
  .cloud-empty p { color: #9fb8c8; margin-top: 12px; }
`;
export const CloudGrid = styled.div`
  flex: 1; min-height: 0; min-width: 0; display: grid; gap: 8px;
  grid-template-columns: repeat(${({ $columns }) => $columns}, minmax(0, 1fr));
  grid-template-rows: repeat(${({ $rows }) => $rows}, minmax(0, 1fr));
`;
export const CloudCardViewport = styled.div`
  position: relative; min-width: 0; min-height: 0; overflow: clip;
`;
export const CloudCard = styled.article`
  box-sizing: border-box; width: ${({ $width = 1280 }) => `${$width}px`}; min-width: 0;
  padding: 12px; background: linear-gradient(140deg, #071c29, #05131d);
  position: absolute; left: 0; top: 0; transform-origin: top left;
  transform: scale(${({ $scale = 1 }) => $scale});
  border: 1px solid #20516b; border-left: 5px solid var(--tone); border-radius: 10px;
  font: 14px Arial, sans-serif; font-variant-numeric: tabular-nums; scroll-margin-top: 70px;
  ${({ $tone }) => $tone === "warning" && css`animation: ${warningFillPulse} 1.55s ease-in-out infinite;`}
  ${({ $tone }) => $tone === "critical" && css`animation: ${dangerFillPulse} 1.35s ease-in-out infinite;`}
  header { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
  h2 { min-width: 0; font-size: 28px; overflow-wrap: anywhere; margin: 0; }
  .cloud-rename { display: grid; place-items: center; padding: 5px; border: 1px solid #285269; border-radius: 4px; background: #061621; color: #8fcde9; cursor: pointer; }
  .cloud-presence { width: 11px; height: 11px; background: var(--tone); border-radius: 50%; flex-shrink: 0; }
  .cloud-badge { padding: 4px 9px; border: 1px solid var(--tone); color: var(--tone); border-radius: 12px; font-size: 13px; }
  .cloud-meta { color: #a9c4d5; font-size: 14px; margin: 5px 0 8px; line-height: 1.3; }
  .cloud-gauges { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); margin-bottom: 8px; }
  .cloud-gauge { min-width: 0; text-align: center; padding: 0 8px; }
  .cloud-gauge + .cloud-gauge { border-left: 1px solid #163848; }
  .cloud-gauge h3 { font-size: 16px; margin: 0 0 3px; }
  .cloud-gauge svg { display: block; width: 128px; max-width: 100%; height: auto; margin: auto; }
  .cloud-gauge small { display: block; color: #c6d8e3; font-size: 13px; line-height: 16px; }
  .cloud-charts { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }
  .cloud-chart, .cloud-network, .cloud-section { min-width: 0; border: 1px solid #1a4053; border-radius: 8px; padding: 8px 10px; background: rgba(2, 17, 26, 0.2); }
  .cloud-chart h3 { font-size: 16px; margin: 0 0 4px; color: #e2f0f8; }
  .cloud-plot { height: calc(150px + var(--cloud-extra-height, 0px) * 0.5); min-width: 0; }
  .cloud-no-history { height: calc(150px + var(--cloud-extra-height, 0px) * 0.5); display: grid; place-items: center; color: #96b3c6; font-size: 14px; }
  .cloud-network { margin-top: 8px; }
  .cloud-network-header { display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; }
  .cloud-network-header h3 { display: flex; align-items: center; gap: 7px; margin: 0; color: #e2f0f8; font-size: 16px; }
  .cloud-network-header h3 svg { color: #2ad0ed; }
  .cloud-network-legend { display: flex; flex-wrap: wrap; gap: 16px; color: #bcd1df; font-size: 13px; }
  .cloud-network-legend span::before { content: ""; display: inline-block; width: 9px; height: 9px; margin-right: 6px; border-radius: 50%; }
  .cloud-network-legend .rx::before { background: #2ad0ed; }
  .cloud-network-legend .tx::before { background: #8b6cff; }
  .cloud-network-legend strong { color: #eaf5fb; font-size: 14px; }
  .cloud-network-plot, .cloud-network-empty { width: 100%; height: calc(174px + var(--cloud-extra-height, 0px) * 0.5); min-width: 0; }
  .cloud-network-empty { display: grid; place-items: center; color: #96b3c6; font-size: 14px; }
  .cloud-memory { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 8px; padding: 8px 0; }
  .cloud-memory > div { padding-left: 12px; }
  .cloud-memory > div + div { border-left: 1px solid #244759; }
  .cloud-memory span { display: block; font-size: 13px; color: #b1cbdc; margin-bottom: 3px; }
  .cloud-memory strong { font-size: 17px; }
  .cloud-details { display: grid; grid-template-columns: 1.12fr 1fr; gap: 8px; align-items: stretch; }
  .cloud-section h3 { font-size: 16px; display: flex; align-items: center; gap: 6px; flex-wrap: wrap; margin: 0 0 8px; }
  .cloud-section h3 small { margin-left: auto; color: #b1cbdc; font-weight: 400; font-size: 12px; }
  .cloud-cores { display: grid; grid-template-columns: repeat(6, minmax(0, 1fr)); gap: 7px 12px; }
  .cloud-core-label { display: flex; justify-content: space-between; gap: 3px; font-size: 12px; color: #c2d9e8; }
  .cloud-core-label strong { font-weight: 500; color: #edf6fe; }
  .cloud-core-track { display: block; height: 8px; margin: 3px 0 0; background: #203b4b; border-radius: 3px; overflow: hidden; }
  .cloud-core-track span { display: block; height: 100%; transition: width 0.4s ease; }
  .cloud-table-scroll { min-width: 0; }
  table { width: 100%; table-layout: fixed; border-collapse: collapse; white-space: nowrap; font-size: 14px; }
  th { text-align: left; color: #b1cbdc; font-weight: 500; padding: 4px 8px 5px 0; }
  td { padding: 4px 8px 4px 0; border-top: 1px solid #16394a; }
  td, th { overflow: hidden; text-overflow: ellipsis; }
  .cloud-disk-section th:nth-child(1) { width: 22%; }
  .cloud-disk-section th:nth-child(2) { width: 34%; }
  .cloud-disk-section td:nth-child(2) { white-space: normal; }
  .cloud-disk-section th:nth-child(3) { width: 23%; }
  .cloud-disk-section th:nth-child(4) { width: 21%; }
  .cloud-bar { display: inline-block; width: 35%; max-width: 52px; height: 8px; background: #203b4b; border-radius: 4px; margin-left: 6px; overflow: hidden; }
  .cloud-bar i { display: block; height: 100%; border-radius: inherit; }
  .cloud-processes { margin-top: 8px; }
  .cloud-process-heading { display: flex; flex-wrap: wrap; align-items: center; gap: 14px; margin-bottom: 5px; }
  .cloud-process-heading h3 { flex-shrink: 0; margin: 0; }
  .cloud-process-options { display: flex; gap: 8px; flex: 1; min-width: 280px; }
  .cloud-process-options input, .cloud-process-options select { min-width: 0; color: #c6ddec; background: #061621; border: 1px solid #285269; padding: 5px 8px; border-radius: 4px; font-size: 13px; }
  .cloud-process-options input { flex: 1; }
  .cloud-process-count { color: #a9c4d5; font-size: 12px; }
  .cloud-processes th:nth-child(1) { width: 10%; }
  .cloud-processes th:nth-child(2) { width: 29%; }
  .cloud-processes th:nth-child(3) { width: 17%; }
  .cloud-processes th:nth-child(4) { width: 12%; }
  .cloud-processes th:nth-child(5) { width: 20%; }
  .cloud-processes th:nth-child(6) { width: 12%; }
  .cloud-pagination { display: flex; align-items: center; justify-content: flex-end; gap: 8px; margin-top: 5px; color: #b2cbdc; font-size: 12px; }
  .cloud-pagination button { border: 1px solid #285269; background: #061621; color: #5ecfff; border-radius: 3px; padding: 1px 7px; cursor: pointer; }
  .cloud-pagination button:disabled { opacity: 0.35; cursor: default; }
  footer { padding-top: 6px; display: flex; gap: 4px 14px; flex-wrap: wrap; color: #9abed2; font-size: 12px; }
  .cloud-warning { font-size: 13px; color: #f5be54; margin: 5px 0; }
`;
